import PropTypes from 'prop-types'
import React from 'react'

import classnames from 'classnames'

import './SVGIcons.scss'

export const IconSLIWrapper = ({
  className,
  children,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip,
  'data-for': dataFor,
  inline
}) => {
  return (
    <span
      className={classnames(
        'c-svg-icon',
        'c-svg-icon--sli',
        {
          'c-svg-icon--inline': inline
        },
        className
      )}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
      data-for={dataFor}
    >
      {children}
    </span>
  )
}

IconSLIWrapper.defaultProps = {
  inline: true
}

IconSLIWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string,
  'data-for': PropTypes.string,
  inline: PropTypes.bool
}
